export default defineNuxtPlugin(async (nuxtApp) => {
  // Only run on client side (navigator is not available on server)
  if (import.meta.server) return;

  const { user } = useUser();
  const i18n = nuxtApp.$i18n as any;
  const router = nuxtApp.$router as any;
  // Localized public URLs (`/vi/downloader`) own their locale; the saved
  // interface language must not flip the page after hydration.
  const onLocalizedPage = () => Boolean(router?.currentRoute?.value?.meta?.seoLang);

  // Watch changes in user state
  watch(
    () => user.value,
    async (newUser) => {
      if (newUser?.id) {
        if (!newUser.interface_language) {
          try {
            const browserLanguage = navigator.language.split("-")[0];

            await $fetch("/api/user/interface-language", {
              method: "POST",
              body: { interface_language: browserLanguage },
            });

            newUser.interface_language = browserLanguage;
            if (!onLocalizedPage()) await i18n.setLocale(browserLanguage);
          } catch (error) {
            console.error("Error setting initial language:", error);
          }
        } else if (i18n.locale.value !== newUser.interface_language && !onLocalizedPage()) {
          try {
            await i18n.setLocale(newUser.interface_language);
          } catch (error) {
            console.error("Error setting user preferred language:", error);
          }
        }
      }
    },
    { immediate: true }
  );
});
